const getTableMeta = (meta) => {
  return {
    current: meta?.page || 1,
    pageSize: meta?.per_page || 10,
    total: meta?.total || 0,
    showSizeChanger: true,
    pageSizeOptions: ['10', '20', '40'],
  }
}

export { getTableMeta }
